import { createContext } from 'react';

const FormFieldContext = createContext({
  projectId: null,
  recipientId: null,
  participationId: null,
  trackId: null,
  state: null,
  payload: [],
});

export default FormFieldContext;
